import { VortexUICurrentAttempt } from "../../../../../components/ui/hud/VortexUI";
import BaseScenarioPart from "../../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { constants } from "../../../../../misc/constants";
import { globals } from "../../../../../misc/globals";
import { Windows, forceRerenderUI } from "../../../../../misc/tools";
import { DaarcBaseScenario, Window508Type } from "../../../../DaarcBaseScenario";
import { SuccessType } from "../../../general-scenario-stuff";
import GeneralProceduresAuscultateMain, { AuscultateProcedureConfig, GeneralProceduresAuscultateMainConfig, GeneralProceduresAuscultatePart1Config } from "../GeneralProceduresAuscultateMain";
var isEtc02Attached = false;

export default class Auscultate extends BaseScenarioPart<DaarcBaseScenario> {
	private get procedure(): AuscultateProcedureConfig {
        switch(this.scenarioConfig.procedure) {
            case VortexUICurrentAttempt.BVM:
                return this.config.bvmConfig;
            case VortexUICurrentAttempt.ETT:
                return this.config.ettConfig;
            case VortexUICurrentAttempt.SGA:
                return this.config.sgaConfig;
            default: //cric
                return this.config.cricConfig;
		}
	}

	private get config(): GeneralProceduresAuscultatePart1Config {
		return this.scenarioConfig.part1Config;
	}
	constructor(private main: GeneralProceduresAuscultateMain, private _scenario: DaarcBaseScenario, private onDone: (isYesClicked: boolean) => void, private id: string, private scenarioConfig: GeneralProceduresAuscultateMainConfig) {
		super(_scenario);
	}

	public get partId(): string {
		return this.id;
	}

	public get videoUrl(): string[] {
		return [this.config.videoUrl];
	}

	public start() {
		this.step1MoveToAuscultateScreen();
	}

	public step1MoveToAuscultateScreen() {
		const context = this;
		context.main.loopVideo(this, context.procedure.moveToAuscultateScreenVideoChapter());
		context.step2DisplayAuscultateUI(false, false, false);
	}

	public step2DisplayAuscultateUI(hasCheckedChest: boolean, hasAuscultated: boolean, ignoreAudio?: boolean) {
		const context = this;
		const showPatentAirway = isEtc02Attached && hasCheckedChest && hasAuscultated;
		if(showPatentAirway && !ignoreAudio) {
			const audio = context.procedure.audioPath();
			// const audio = context.config.successType() === SuccessType.Success ? './assets/audio/auscultate/vortexreaderreminder_fail.mp3' : './assets/audio/auscultate/vortexreaderreminder_success2.mp3';
			context._scenario.gameManager.SoundManager.playSound({
				src: audio,
				loop: false,
				oneShot: true,
				playsInline: true,
				autoPlay: true,
				enableClosedCaptioning: false,
				muted: globals.isMuted,
				volume: 1
			});
		}
		this.scenario.update508Window(Window508Type.Auscultate);
		
		context.scenario.uiWrapper.displayAuscultateUI({
			onPatentAirwayNoClicked: () => {
				if(!context.procedure.isAnswerCorrect(false)) {
					context.scenario.displayMessage('This is not the correct answer', () => {
						context.step2DisplayAuscultateUI(true, true, true);
					});
				} else {
					if(context.scenario.auscultateAudio) {
						context.scenario.gameManager.SoundManager.playSound({
							src: context.scenario.auscultateAudio,
							autoPlay: true,
							enableClosedCaptioning: false,
							muted: globals.isMuted,
							volume: 1
						});

						context.scenario.auscultateAudio = undefined;
					}
					
					context.onDone(false);
				}
			},
			onPatentAirwayYesClicked: () => {
				if(!context.procedure.isAnswerCorrect(true)) {
					context.scenario.displayMessage('This is not the correct answer', () => {
						context.step2DisplayAuscultateUI(true, true, true);
					});
				} else {
					if(context.procedure.onBeforeDebriefShows) {
						context.procedure.onBeforeDebriefShows(() => {
							context.onDone(true);
						})
					} else {
						context.onDone(true);
					}
				}
				
				// alert('Congratulations on completing the scenario! Redirecting to the main menu...');
				// context._scenario.gameManager.customData.updateWindow(Windows.MainMenu);
			},
			showPatentAirwayMessage: showPatentAirway,
			buttons: [
				{
					title: 'Attach & Assess ETC02',
					isDisabled: isEtc02Attached,
					onClicked: () => {
						isEtc02Attached = true;
						context._scenario.sideMenuId = context.scenario.uiWrapper.displaySideMenu({
							updatedStuff: {
								showETC02: isEtc02Attached,
							}
						}, context._scenario.sideMenuId);
						context.step3DisplayIndicationUI('Attach ETC02 in Progress', hasCheckedChest, hasAuscultated, () => {
							context.scenario.gameManager.SoundManager.playSound({
								src: './assets/audio/auscultate/ETCO2connected.mp3',
								autoPlay: true,
								enableClosedCaptioning: false,
								muted: globals.isMuted,
								volume: 1
							});
							// context.playVideoChapter(context._videoChapters.step2RTETC02Connected, () => {
							// });
						});
					}
				},
				{
					title: 'Check chest rise & tube humidification',
					isDisabled: hasCheckedChest,
					onClicked: () => {
						context.step4DisplayFloatingUI(this.procedure.checkRiseAndTubeHumidificationText(), true, hasAuscultated);
					}
				},
				{
					title: 'Auscultate',
					isDisabled: hasAuscultated,
					onClicked: () => {
						context.step5DisplayFloatingUIForAuscultate(hasCheckedChest, true);
					}
				}
			]
		});
	}

	public step3DisplayIndicationUI(msgTxt: string, hasCheckedChest: boolean, hasAuscultated: boolean, onDone?: () => void) {
		const context = this;
		context.scenario.uiWrapper.destroyAllUIInstances();
		forceRerenderUI(constants.uiNames.AuscultateUI);

		var onDoneWithPopup = context._scenario.doSomething(msgTxt);
		setTimeout(() => {
			onDoneWithPopup();
			if(onDone) {
				onDone();
			}
			context.step2DisplayAuscultateUI(hasCheckedChest, hasAuscultated)
		}, constants.doSomethingTimeout);
	}

	public step4DisplayFloatingUI(msgTxt: string, hasCheckedChest: boolean, hasAuscultated: boolean) {
		const context = this;
		context.scenario.uiWrapper.destroyAllUIInstances();
		forceRerenderUI(constants.uiNames.AuscultateUI);

		this.scenario.uiWrapper.displayFloatingMessagesUI({
			isDebug: true,
			messages: [
				{
					top: '450px',
					left: '800px',
					showMessage: true,
					title: msgTxt,
					onDismissed: () => {
						context.step2DisplayAuscultateUI(hasCheckedChest, hasAuscultated)
					}
				}
			]
		});
	}

	public step5DisplayFloatingUIForAuscultate(hasCheckedChest: boolean, hasAuscultated: boolean) {
		const context = this;
		context.scenario.uiWrapper.destroyAllUIInstances();
		forceRerenderUI(constants.uiNames.AuscultateUI);

		context._scenario.uiWrapper.displayNotificationUI({
			text: `<p class='notification-text'>Hover on the patient's chest and abdomen to auscultate</p>`,
			onDismissed: () => {
			}
		})

		var counter = 0;

		var hoverOverMessages = this.procedure.auscultateHoverOverMessages();

		var validate = () => {
			if(counter >= hoverOverMessages.length) {
				context.step2DisplayAuscultateUI(hasCheckedChest, hasAuscultated)
			}
		}

		for(var indx = 0; indx < hoverOverMessages.length; indx++) {
			hoverOverMessages[indx].onDismissed = () => {
				counter++;
				validate();
			};
			
			hoverOverMessages[indx]['showMessage'] = undefined;
			hoverOverMessages[indx]['hideHotspot'] = undefined;
			hoverOverMessages[indx]['timeout'] = undefined;
		}

		context.scenario.uiWrapper.displayFloatingMessagesUI({
			isDebug: true,
			messages: hoverOverMessages
			// [
            //     // {
            //     //     top: '100px',
            //     //     left: '100px',
            //     //     title: 'Left lung: breath sounds',
            //     //     onDismissed: () => {
            //     //         counter++;
            //     //         validate();
            //     //     }
            //     // },
            //     // {
            //     //     top: '200px',
            //     //     left: '200px',
            //     //     title: 'Right lung: breath sounds',
            //     //     onDismissed: () => {
            //     //         counter++;
            //     //         validate();
            //     //     }
            //     // },
            //     // {
            //     //     top: '300px',
            //     //     left: '300px',
            //     //     title: 'Abdomen: no sound',
            //     //     onDismissed: () => {
            //     //         counter++;
            //     //         validate();
            //     //     }
            //     // }
            // ]
		});
	}
}